import React, { Suspense } from "react";
import { FormattedMessage, defineMessages, injectIntl } from "react-intl";
import { IconClose } from "../../icons/svg";
import ChatMessage from '../chat-message.jsx'
import * as MC_CONST from '../../tinode/constants.js'
import { makeImageUrl } from '../../lib/blob-helpers.js';



const messages = defineMessages({
	info_search: {
		id: "info_search",
		defaultMessage: "Search in chat",
		description: "Search in chat",
	},
	find_result_notify: {
		id: "find_result_notify",
		defaultMessage: "This is the interface displaying messages with the keyword \"{keyWord}\" along with 30 neighboring messages.",
		description: "Find result notify"
	}
})

class FindMessageResult extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isSendText: false,
		}

		this.scrollToMessage = this.scrollToMessage.bind(this)
		this.getOrCreateMessageRef = this.getOrCreateMessageRef.bind(this)
	}

	componentDidMount() {
		this.scrollToMessage(this.props.seqId)
	}

	componentDidUpdate(prevProps) {
		if (prevProps.seqId !== this.props.seqId) {
			this.scrollToMessage(this.props.seqId)
		}
	}

	getOrCreateMessageRef(seqId) {
    if (this.props.tinode._findMessageRefs.hasOwnProperty(seqId)) {
      return this.props.tinode._findMessageRefs[seqId];
    }
    const ref = React.createRef();
    this.props.tinode._findMessageRefs[seqId] = ref;
    return ref;
  }

	scrollToMessage(seqId) {
    // Scroll tới tin nhắn
    const { _findMessageRefs } = this.props.tinode
    if (_findMessageRefs.hasOwnProperty(seqId)) {
      const ref = _findMessageRefs[seqId]
      ref.current.scrollIntoView({ block: "center" })
      ref.current.classList.add('flash');
      setTimeout(_ => { ref.current.classList.remove('flash') }, 1000);
    }
	}

	renderListMessage() {
		const topic = this.props.tinode.getTopicByName(this.props.topicName)
		const messageNodes = [];
		
		const groupTopic = topic.isGroupType();

		this.props.listMessage.forEach((msg) => {

			let pollMsg = {};
			if (isVote) {
				pollMsg = topic.findPollMessageById(msg.id)
			}

			let replyToSeq = msg.head ? parseInt(msg.head.reply) : null;
			if (!replyToSeq || isNaN(replyToSeq)) {
				replyToSeq = null;
			}

			let thisFrom = msg.from || 'chan';

			let sequence = 'single';

			const isReply = !(thisFrom == this.props.myUserId);

			const isOwnMessages = (thisFrom == this.props.myUserId);

			const isNotify = msg.subtype === MC_CONST.NODE_SUBTYPE_MESSAGE.NOTIFY
			const isVote = msg.subtype === MC_CONST.NODE_SUBTYPE_MESSAGE.VOTE;

			let userFrom = thisFrom, userName, userAvatar;
			let topicInfo = this.props.tinode.getTopicByName(thisFrom, { isCreateWhenNotExist: true });
			if (topicInfo) {
				userName = topicInfo.getTopicName();
				userAvatar = makeImageUrl(topicInfo.public.photo);
			}

			const deliveryStatus = topic.msgStatus(msg, true);

			const ref = this.getOrCreateMessageRef(msg.seq);

			messageNodes.push(
				<ChatMessage
					isOfficial={topic && topic.isOfficial ? topic.isOfficial : false}
					msg={msg}
					pollMsg={pollMsg}
					tinode={this.props.tinode}
					content={msg.content}
					tags={msg.tags}
					tagAll={msg.tagAll}
					topic={this.props.topicName}
					previewLink={msg.previewLink}
					mimeType={msg.head && msg.head.mime}
					isSimplify={true}
					replyToSeq={replyToSeq}
					edited={msg.head && !msg.head.webrtc && msg.head.replace}
					timestamp={msg.ts}
					response={isReply}
					isOwnMessages={isOwnMessages}
					seq={msg.seq}
					isGroup={groupTopic}
					isChan={this.state.channel}
					isNotify={isNotify}
					isVote={isVote}
					userFrom={userFrom}
					userName={userName}
					userAvatar={userAvatar}
					sequence={sequence}
					received={deliveryStatus}
					ref={ref}
					key={msg.seq}
				/>
			)
		})
		const chatBoxClass = groupTopic ? 'chat-box group' : 'chat-box';

		return (
			<div id="messages-container-2">
			<div id="messages-panel-2">
				<ul id="scroller" className={chatBoxClass}>
					{messageNodes}
				</ul>
			</div>
			</div>
		)
	}


	render() {
		const { formatMessage } = this.props.intl;

		return (
			<Suspense
				fallback={
					<div className="panel-form-row">
						<FormattedMessage
							id="loading_note"
							defaultMessage="Loading..."
							description="Message shown when component is loading"
						/>
					</div>
				}>
				<div className="dialog-find-message-result">
					<div className="header">
						<div className="title">
							{formatMessage(messages.info_search)}
						</div>
						<div className="icon" onClick={this.props.onClose}>
							<IconClose />
						</div>
					</div>
					<div className="find-message-notify">{formatMessage(messages.find_result_notify, { keyWord: this.props.keyWord })}</div>
					<div>
						{this.renderListMessage()}
					</div>
				</div>
			</Suspense>
		)
	}
}

export default injectIntl(FindMessageResult);